import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, FormArray, Validators } from '@angular/forms';
import { Lead } from '../../../../../shared/lead';
import { PostLead } from '../../../../../shared/post-lead';
import { FormResponse } from '../../../../../shared/form-response';
import { leadValues } from '../../../../../services/lead-values.service';
import { FruHttpService } from '../../../../../services/fru-http.service';
import { JornayaService } from '../../../../../services/jornaya.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'buy-within-90-form',
  templateUrl: './buy-within-90-form.component.html',
  styleUrls: ['./buy-within-90-form.component.scss']
})

export class BuyWithin90FormComponent implements OnInit {
  @Input() lead: Lead;

  public leadForm: UntypedFormGroup;
  public leadValues: Object;
  public disableSubmit: boolean = false;
  public buyingProcessControl;
  public veteranMilitaryControl;
  public zipCodeControl;
  public firstNameControl;
  public lastNameControl;
  public emailControl;
  public phoneControl;
  redirectTries: number = 0;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private fruHttp: FruHttpService,
    private elRef:ElementRef,
    private jornayaService: JornayaService,
    private deviceService: DeviceDetectorService,
    ) {
    this.leadValues = leadValues;
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    // Adjust some numbers that might not exactly match the form dropdown
    let purchasePrice = this.getClosestValue(this.lead.purchasePrice, leadValues.purchasePrices);
    let cashOut = this.getClosestValue(this.lead.cashOut, leadValues.cashOuts);
    let propertyValue = this.getClosestValue(this.lead.propertyValue, leadValues.propertyValues);
    let firstMortgageBalance = this.getClosestValue(this.lead.firstMortgageBalance, leadValues.firstMortgageBalances);

    // Set up form
    this.leadForm = this.formBuilder.group({
      rateType: this.formBuilder.control(this.lead.rateType),
      propertyType: this.formBuilder.control(this.lead.propertyType),
      propertyUse: this.formBuilder.control(this.lead.propertyUse),
      creditRating: this.formBuilder.control(this.lead.creditRating),
      zipCode: this.formBuilder.control(this.lead.zipCode, [Validators.required, Validators.pattern(/^(\d{5})$/)]),
      veteranMilitary: this.formBuilder.control(this.lead.veteranMilitary),
      firstName: this.formBuilder.control(this.lead.firstName, [Validators.required, Validators.minLength(2)]),
      lastName: this.formBuilder.control(this.lead.lastName, [Validators.required, Validators.minLength(2)]),
      email: this.formBuilder.control(this.lead.email, [Validators.required, Validators.email]),
      phone: this.formBuilder.control(this.lead.phone, [Validators.required, Validators.pattern(/(\(\d{3}\) \d{3}-\d{4})|\d{10}/)])
    });

    // Type specific fields
    switch(this.lead.type) {
      case 'purchase':
        this.leadForm.addControl('purchasePrice', this.formBuilder.control(purchasePrice));
        this.leadForm.addControl('downPayment', this.formBuilder.control(this.lead.downPayment));
        this.leadForm.addControl('buyingProcess', new UntypedFormControl('days_from_buying'));
        this.leadForm.addControl('daysFromBuying', new UntypedFormControl('yes'));
        this.leadForm.addControl('foundHome', this.formBuilder.control(this.lead.foundHome));
        this.leadForm.addControl('signedAgreement', this.formBuilder.control(this.lead.signedAgreement));
        break;
    }

    this.leadForm.addControl('formVersion', new UntypedFormControl('buy-within-90'));
    this.leadForm.addControl('adnetwork', new UntypedFormControl('within90_campaign'));
  }

  onSubmitForm() {
    this.disableSubmit = true;

    // If this is mobile, slow down
    if (this.deviceService.isMobile()) {
      let seconds = this.jornayaService.secondsSinceLoaded();

      if (seconds === null) {
        if (++this.redirectTries <= 6) {
          // Wait for Jornaya
          setTimeout(function() {
            this.onSubmitForm();
          }.bind(this), 500);
        }
      } else {
        this.submitForm();
      }
    } else {
      this.submitForm();
    }
  }

  submitForm() {
    // Get injected elements from tracking scripts
    let trustedForm = this.elRef.nativeElement.querySelector('[name=xxTrustedFormCertUrl]');
    this.lead.trusted_form_cert_url = (trustedForm !== null) ? trustedForm.value : null;

    let leadId = this.elRef.nativeElement.querySelector('[name=universal_leadid]');
    this.lead.universal_leadid = (leadId !== null) ? leadId.value : null;

    // Assign form values
    this.lead = Object.assign(this.lead, this.leadForm.value);

    // Strip things from phone
    this.lead.phone = this.lead.phone.replace(/[^\d]/g, '').slice(0, 10);

    // Submit the lead
    let postLead = new PostLead(this.lead);
    this.fruHttp.submitLead(postLead)
      .subscribe(response => {
        this.handleResponse(response);
      });
  }

  getClosestValue(goal: number, numbers: any[]) {
    // Assuming 'numbers' will be one of the key/value array of objects for form values
    let values = [];
    for (let k in numbers) {
      values.push(numbers[k].key);
    }

    let closest = values.reduce((prev, curr) => Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);

    return closest;
  }

  handleResponse(response: FormResponse) {
    // Watch for malformed response
    if (typeof response.status === 'undefined' || !response.status) {
      this.fruHttp.redirectOffersPurchase(this.lead);
      return;
    }

    switch (response.status) {
      case 'New':
      case 'Sent':
      case 'Block':
      case 'Review':
      case 'Not Sendable':
        // Go to thank you page
        this.fruHttp.redirectThankYou(this.lead, response);
        break;

      default:
        // Go to offers page
        this.fruHttp.redirectOffersPurchase(this.lead);
        break;
    }
  }

  justThinking() {
    this.fruHttp.redirectOffersPurchase(this.lead);
    return;
  }
}
